<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
              @limitChanged="limitChanged"
        @download="download"
        @onChangeAccsGroup="onChangeAccsGroup"/>

    <basic-table
      @Filtred="Filtred"
      :items="payments"
      :fields="paymentsFields"
      :filter="filter"
      :filterOn="filterFields"
      :per-page="perPage"
      :current-page="currentPage"
      :totalRows="totalRows"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import download from '@/utils/downloadFile'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accs_group_id: 0,
        accounting_period_id: 0,
        limit: 500,
        download: 0
      },
      userList: [],
      currencies: [],
      methods: [],
      payments: [],
      stateToString: {0: this.$i18n.t('Error'), 1: 'Ok', 2: this.$i18n.t('Wait'), 3: this.$i18n.t('Canceled')},
      filterFields: ['id', 'account_id', 'login', 'full_name', 'transaction_time', 'payment_system_name', 'state'],
      paymentsFields: [
        {key: 'id', label: this.$i18n.t('ID'), sortable: true},
        {key: 'transaction_id', label: this.$i18n.t('Transaction ID'), sortable: true},
        {key: 'amount',
          label: this.$i18n.t('Amount (in currency)'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('FullName'), sortable: true},
        {key: 'personal_account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'modified', label: this.$i18n.t('Modified'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'transaction_time', label: this.$i18n.t('Transaction Time'), sortable: true, formatter: (val, key, item) => { return val === 0 ? '' : this.intToDate(val > 1000000000000 ? val / 1000 : val) }},
        {key: 'payment_system_name', label: this.$i18n.t('PS Name'), sortable: true},
        {key: 'state', label: this.$i18n.t('State'), sortable: true, formatter: (val, key, item) => { return this.stateToString[val] }},
        {key: 'iso_currency_code', label: this.$i18n.t('Currency Code'), sortable: true},
        {key: 'deleted', label: this.$i18n.t('Deleted?'), sortable: true, formatter: (val, key, item) => { return val === 1 ? this.$i18n.t('Yes') : this.$i18n.t('No') }}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      selectAccsGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: true,
        isFilterAccsGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: true
      }
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    async load (isGenerateClick = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      var numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
        this.getStore.accs_group_id = this.selectAccsGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_PAYMENT_ORDERS', this.getStore).then(response => {
        if (isGenerateClick) {
          this.payments = this.$store.getters['Reports/PAYMENT_ORDERS']
        } else {
          download(this.$store.getters['Reports/PAYMENT_ORDERS'], 'report_payments_payment_orders.csv', 'text/csv')
        }

        this.loadDone()
      })
      this.totalRows = this.payments.length
      this.$emit('input', this.totalRows)
    },
    intToDate (val) {
      return this.$root.showDataWithTZDelta(val)
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_PAYMENT_ORDERS')
      this.getStore.download = 0
      this.totalRows = 0
      this.payments = []
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    onChangeAccsGroup (value) {
      this.selectAccsGroup = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()

    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/payments/paymentOrders/main.vue